import { StyledFlex } from './flex.styled';

/**
 * Provides Flexbox utilities for JSX
 */
export const Flex = StyledFlex;

export default Flex;
